import script from "./SchoolSelectionInput.vue?vue&type=script&setup=true&lang=js"
export * from "./SchoolSelectionInput.vue?vue&type=script&setup=true&lang=js"

import "./SchoolSelectionInput.vue?vue&type=style&index=0&id=010f362a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-010f362a"]])

export default __exports__